/* rb-m-roe.js -- "Rooster Rotation / Hand picked outfits" on phones. 22 Sep 2026.

   The section (rooster-outfit-editorial) stacks its desktop layout on a
   phone: headline + intro, tabs, a 4:3 image, then a card that repeats the
   name, arrows, a five-line paragraph, a SCROLL BOX of products, the add
   button, a link and dots -- 1,221px for one outfit, three ways to change
   outfit, and a nested scroll that fights the page.

   This module reads the data the section already rendered (tabs, panels,
   images, product links, add buttons) and renders a phone layout beside it;
   the original .roe-wrap is hidden by CSS on phones only. Nothing in the
   section's own JS is touched: a chip tap clicks the real tab button, "Add
   the full outfit" clicks the real .roe-add-fit for that panel so the
   theme's size modal, cart add and messages run unchanged.

   Layout (Mark picked "C" of three, 22 Sep): one card per outfit in a
   horizontal snap rail with dots and "1 / 5" -- square image with the name
   tag, the pieces as line items, "Add outfit . $total" in the card. The
   rejected "B" (chips + split card) lives in git history if ever wanted. */
(function () {
  'use strict';
  if (!window.RBM) return;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, ''); }
  function shortPrice(s) { return String(s || '').trim().replace(/\.00\b/, ''); }


  function read(sec) {
    var triggers = Array.prototype.slice.call(sec.querySelectorAll('[data-outfit-trigger]'));
    return triggers.map(function (t) {
      var id = t.getAttribute('data-outfit-trigger');
      var panel = sec.querySelector('[data-outfit-panel="' + id + '"]');
      var imgWrap = sec.querySelector('[data-outfit-image="' + id + '"]');
      var img = imgWrap && imgWrap.querySelector('img');
      var link = imgWrap && imgWrap.querySelector('a');
      var products = panel ? Array.prototype.map.call(panel.querySelectorAll('.roe-product'), function (a) {
        var pi = a.querySelector('img');
        return { href: a.getAttribute('href'), img: pi ? (pi.getAttribute('src') || '') : '', name: (a.querySelector('h4') || {}).textContent || '', price: (a.querySelector('p') || {}).textContent || '' };
      }) : [];
      var total = products.reduce(function (s, p) { var n = parseFloat(String(p.price).replace(/[^0-9.]/g, '')); return s + (isNaN(n) ? 0 : n); }, 0);
      var shop = panel && panel.querySelector('.roe-shop-link');
      return {
        id: id, trigger: t, panel: panel,
        name: t.textContent.trim(),
        copy: ((panel && panel.querySelector('.roe-panel-head p')) || {}).textContent || '',
        img: img ? (img.getAttribute('src') || '') : '', srcset: img ? (img.getAttribute('srcset') || '') : '',
        href: (link && link.getAttribute('href')) || (shop && shop.getAttribute('href')) || '#',
        products: products, total: total,
        add: panel && panel.querySelector('.roe-add-fit')
      };
    });
  }

  function pieceRow(p) {
    return '<a class="rbm-roe__line" href="' + esc(p.href) + '">' +
      '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="500" height="500">' +
      '<span class="rbm-roe__pname">' + esc(p.name.trim()) + '</span>' +
      '<span class="rbm-roe__pprice">' + esc(shortPrice(p.price)) + '</span></a>';
  }

  function head(sec, extra) {
    var kicker = (sec.querySelector('.roe-kicker') || {}).textContent || 'Rooster Rotation';
    return '<div class="rbm-roe__head"><div>' +
      '<p class="rbm-roe__kicker">' + esc(kicker.trim()) + '</p>' +
      '<h2 class="rbm-roe__title">Hand picked<br>outfits</h2></div>' + (extra || '') + '</div>';
  }


  function render(sec, looks) {
    var root = document.createElement('div');
    root.className = 'rbm-roe';
    root.innerHTML = head(sec, '<span class="rbm-roe__count"><b>1</b> / ' + looks.length + '</span>') +
      '<div class="rbm-roe__rail rbm-hs">' + looks.map(function (l, i) {
        return '<article class="rbm-roe__card" data-i="' + i + '">' +
          '<a class="rbm-roe__cimg" href="' + esc(l.href) + '"><img src="' + esc(l.img) + '" alt="' + esc(l.name) + '" loading="' + (i ? 'lazy' : 'eager') + '" width="1200" height="900"><h3 class="rbm-roe__tag">' + esc(l.name) + '</h3></a>' +
          '<div class="rbm-roe__cbody">' +
            l.products.map(pieceRow).join('') +
            '<button type="button" class="rbm-roe__add" data-i="' + i + '">Add outfit &middot; ' + money(l.total) + '</button>' +
          '</div></article>';
      }).join('') + '</div>' +
      '<div class="rbm-roe__dots">' + looks.map(function (_, i) { return '<i' + (i === 0 ? ' class="is-on"' : '') + '></i>'; }).join('') + '</div>';
    var rail = root.querySelector('.rbm-roe__rail');
    var dots = root.querySelectorAll('.rbm-roe__dots i');
    var count = root.querySelector('.rbm-roe__count b');
    rail.addEventListener('click', function (e) {
      var b = e.target.closest('.rbm-roe__add'); if (!b) return;
      var l = looks[parseInt(b.getAttribute('data-i'), 10)];
      if (l.trigger && !l.trigger.classList.contains('active')) l.trigger.click();
      if (l.add) l.add.click();
    });
    rail.addEventListener('scroll', RBM.debounce(function () {
      var cards = rail.querySelectorAll('.rbm-roe__card'); if (!cards.length) return;
      var step = cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth;
      var i = Math.max(0, Math.min(cards.length - 1, Math.round(rail.scrollLeft / step)));
      Array.prototype.forEach.call(dots, function (d, k) { d.classList.toggle('is-on', k === i); });
      if (count) count.textContent = i + 1;
    }, 60), { passive: true });
    return root;
  }

  RBM.onMobile('roe', function () {
    var sec = document.querySelector('.rooster-outfit-editorial');
    if (!sec || sec.dataset.rbmRoe) return;
    var looks = read(sec).filter(function (l) { return l.panel && l.products.length; });
    if (looks.length < 2) return;
    sec.dataset.rbmRoe = '1';
    sec.appendChild(render(sec, looks));
    sec.classList.add('rbm-roe-on');
  });
})();
